/**
 * AI Story Studio — Pillar 1 product copy and route helpers.
 * Wraps existing Storybook, Stories & voice, and Legacy Book export flows.
 */

export const STORY_STUDIO_TAGLINE =
  'Capture memories by voice, text or prompts, then shape them into chapters and Legacy Books.';

export const STORY_STUDIO_SAFETY =
  'AI helps organise and polish what you provide. You stay in control before anything is exported.';

export const STORY_STUDIO_PROCESS_CHIPS = ['Prompt', 'Record', 'Transcribe', 'Polish', 'Export'];

export const STORY_STUDIO_PILLAR_FEATURES = [
  'Storybook Mode',
  'Voice memories',
  'Transcription',
  'AI polish',
  'Chapter drafts',
  'Legacy Book PDF',
];

export const STORY_STUDIO_HUB_CARDS = [
  {
    id: 'storybook',
    title: 'Guided Storybook',
    copy: 'Answer life-story prompts one chapter at a time.',
    button: 'Open Storybook',
    route: '/storybook',
  },
  {
    id: 'voice',
    title: 'Record a voice memory',
    copy: 'Speak naturally. Transcribe and polish later.',
    button: 'Record memory',
    resolve: 'personStoriesVoice',
  },
  {
    id: 'polish',
    title: 'Polish a story',
    copy: 'Turn rough notes or transcript into a readable memory.',
    button: 'Open stories',
    resolve: 'personStories',
  },
  {
    id: 'legacy-book',
    title: 'Prepare Legacy Book',
    copy: 'Review completed stories before exporting.',
    button: 'Preview Legacy Book',
    resolve: 'treeReadiness',
  },
];
